module.exports = __webpack_public_path__ + "img/ZB水表.2db56793.jpg";